export default "__VITE_ASSET__B1cOY0iJ__"